const PUBLIC_KEY_SPKI = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwKVOit6zj4DNUvuKFSGz
mN4RmWllBTmVUlaErzO3cKoIFAnR4eqTm3kBJL1Bvc6oXI//e+cmSdwKDwn5Ol8x
LadLmNcLJQUJtHQyOZBT6SOj31XGAwmmtGysTRqXe7FsPqp0RMC/92Q2bWpfJXbM
sRoCJ0A4FpFCJiXOWY3Fx0We+KYuyhpJwp2w8CrD9IEGI0ch9DbRti5VrYlqtvo3
JqFhifMUgWsx25xgnUCus6MO7fiMLvWxCRWVelTzlUrX7ynwQABmbBVLSa1PZm7J
+1KzDBrj4fZobkGpCtlakbD3AucDtTR5AIBRwcmpWNvCI8cxKIFkWf2L8aGo/9Q5
NwIDAQAB
-----END PUBLIC KEY-----
`;

export class GlobalConstants {
  static readonly publicKeySPKI = PUBLIC_KEY_SPKI;
}
